export const UNASSIGNED_BARBER = 'UNASSIGNED_BARBER';

export const ITEM_TYPE = {
  product: 'product',
  service: 'service',
  appointment: 'appointment',
  charge: 'charge',
  giftCard: 'giftCard',
  membership: 'membership',
};

export const ADJUSTMENTS_TYPE = {
  discount: 'discount',
  promo: 'promo',
  membership: 'membership_discount',
};
